
//导入axios
import axiosRequest from '@/utils/axios-default-request';


//编写aios接口

 //获取我的简历基本信息
 let  getMyresumeBasicInfoData= (data) =>axiosRequest.postBody('/supinterface/getSupResumeData',data);

/** 教育经历 */

 //获取学历信息下拉  
 let  getEducationDataList= (data) =>axiosRequest.postBody('/supinterface/getEducationData',data);


 //新增教育经历
 let  addSupEducation= (data) =>axiosRequest.postBodyJson('/supinterface/saveSupEducation',data);

 //编辑教育经历
 let  editSupEducation= (data) =>axiosRequest.postBodyJson('/supinterface/updateSupEducation',data);

 
 //查询当前教育经历
 let  getSupEducationData= (data) =>axiosRequest.postBody('/supinterface/getSupEducationData',data);


 //删除当前教育经历
 let  delSupEducation= (data) =>axiosRequest.postBody('/supinterface/deleteSupEducation',data);


/** 语言证书 */

 //获取语言证书
 let  getWhLanguageCertificateData= (data) =>axiosRequest.postBody('/supinterface/getWhLanguageCertificateData',data);

 //新增语言证书
 let  addLanguageCertificateData= (data) =>axiosRequest.postBodyJson('/supinterface/saveSupCertificate',data);

// 获取语言证书form表单 getSupCertificateData
let  getSupCertificateData= (data) =>axiosRequest.postBody('/supinterface/getSupCertificateData',data);

 //编辑语言证书
 let  editSupCertificate= (data) =>axiosRequest.postBodyJson('/supinterface/updateSupCertificate',data);


 //删除言证书
 let  delSupCertificate= (data) =>axiosRequest.postBody('/supinterface/deleteSupCertificate',data);

// 下载文件
//  let  downloadFile= (data) =>axiosRequest.postBody('/supinterface/downloadFile',data);


/** 工作经历 */

 //新增工作经历
 let  addSupWorkExperience= (data) =>axiosRequest.postBodyJson('/supinterface/saveSupWorkExperience',data);


//编辑工作经历
let  editSupWorkExperience= (data) =>axiosRequest.postBodyJson('/supinterface/updateSupWorkExperience',data);

//删除工作经历
let  delSupWorkExperience= (data) =>axiosRequest.postBody('/supinterface/deleteSupWorkExperience',data);


//获取工作经历form表单
let  getSupWorkExperienceData= (data) =>axiosRequest.postBody('/supinterface/getSupWorkExperienceData',data);

/** 项目经历 */

//新增项目经历
let  addSupProjectExperience= (data) =>axiosRequest.postBodyJson('/supinterface/saveSupProjectExperience',data);


//编辑项目经历
let  editSupProjectExperience= (data) =>axiosRequest.postBodyJson('/supinterface/updateSupProjectExperience',data);

//删除项目经历
let  delSupProjectExperience= (data) =>axiosRequest.postBody('/supinterface/deleteSupProjectExperience',data);

// 获取项目经历form表单
let getSupProjectExperienceData = (data)=>axiosRequest.postBody('/supinterface/getSupProjectExperienceData',data)



/**自我评价 */

//查询供应商自我评价
let  getSelfEvaluationData= (data) =>axiosRequest.postBody('/supinterface/getSelfEvaluationData',data);

//新增/编辑自我评价
let  addOrEditSupSelfEvaluation= (data) =>axiosRequest.postBodyJson('/supinterface/addOrEditSupSelfEvaluation',data);

//附件简历
//添加附件简历
let addUpSupResumeFile = (data)=>axiosRequest.postBodyJson("/supinterface/upSupResumeFile",data)
//查询附件简历
let getSupResumeFile = (data) =>axiosRequest.postBody("/supinterface/getSupResumeFile",data)

/**
 * 查询工作经历：getSupWorkExperienceData 
添加工作经历： saveSupWorkExperience
更新工作经历：updateSupWorkExperience
删除工作经历：deleteSupWorkExperience
查询供应商项目经历：getSupProjectExperienceData
添加项目经历：saveSupProjectExperience
更新项目经历：updateSupProjectExperience
删除项目经历：deleteSupProjectExperience
 */



export default{
    getMyresumeBasicInfoData,//获取我的简历基本信息
    getEducationDataList,//获取学历下拉列表
    addSupEducation,        // 新增教育经历
    editSupEducation,       //编辑教育经历
    delSupEducation,        //删除当前教育经历
    getSupEducationData,//查询当前教育经历

    getWhLanguageCertificateData, //获取语言证书
    addLanguageCertificateData, // 新增语言证书
    getSupCertificateData,//获取fomr语言表单
    editSupCertificate, // 编辑语言证书
    delSupCertificate, // 删除语言证书

    addSupWorkExperience, //新增工作经历
    getSupWorkExperienceData,//获取工作经历
    editSupWorkExperience,//编辑工作经历
    delSupWorkExperience,//删除工作经历

    addSupProjectExperience,//新增项目经历
    editSupProjectExperience,//编辑项目经历
    delSupProjectExperience,//删除项目经历
    getSupProjectExperienceData,//获取供应商form表单

    addOrEditSupSelfEvaluation,//自我评价
    getSelfEvaluationData,//查询供应商自我评价

    addUpSupResumeFile,//添加附件简历
    getSupResumeFile//查询附件简历
}
